import styled from '@emotion/styled';
import { useOrganization } from '@innovamat/ga-features';
import { EmptyClassroom } from '@innovamat/glimmer-assets';
import { Typography } from '@innovamat/glimmer-components';
import { Trans, useTranslation } from 'react-i18next';

const ErrorWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
`;

const ErrorTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: center;
  align-items: center;
`;

const ErrorTextSubtitle = styled(Typography.Body2)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
  max-width: 800px;
`;

export function NoClassesError(): JSX.Element {
  const { t } = useTranslation();
  const { isRosteringEnabled } = useOrganization();

  return (
    <ErrorWrapper>
      <EmptyClassroom />
      <ErrorTextWrapper>
        <Typography.H4>
          {t('reports.admin.no-classes.error.title')}
        </Typography.H4>
        <ErrorTextSubtitle>
          {isRosteringEnabled ? (
            <Trans
              i18nKey="rostering.action-disabled.message"
              components={{ b: <b /> }}
            />
          ) : (
            t('reports.admin.no-classes.error.description')
          )}
        </ErrorTextSubtitle>
      </ErrorTextWrapper>
    </ErrorWrapper>
  );
}
